import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SignupService } from 'src/app/_services/signup.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-subscription-payment-successful-new',
  templateUrl: './subscription-payment-successful-new.component.html',
  styleUrls: ['./subscription-payment-successful-new.component.scss']
})
export class SubscriptionPaymentSuccessfulNewComponent implements OnInit {

    showModal : boolean = true;
    isRealAccountAccess: boolean = false;
    timeLeft: number = 5;
    totalAmount = 0
    _globals = GlobalService
    constructor(
        public _abd: AppBaseDataService,
        public _signup: SignupService,
        public _userServices:UserService,
        private _router: Router,
        private _connMessageService: ConnMessageService,
        private _spinner: NgxSpinnerService,
    ) { }

    ngOnInit(): void {
        sessionStorage.removeItem('personal-info')
        sessionStorage.removeItem('business-info')
    
        let amount = sessionStorage.getItem('grandTotal')
        if(amount !== null){
            this.totalAmount = JSON.parse(amount)
            this.totalAmount = Number(this.totalAmount)
        }
        //  this._userServices.autologin(false)
          
        // verify valid account
        // localStorage.clear();
        // let paymentSuccessfully: any = sessionStorage.getItem('payment-successfully');
        // if (paymentSuccessfully != undefined ){
        //     this.isRealAccountAccess = (paymentSuccessfully == "1" ? true: false)
        //    // sessionStorage.clear()

        //     sessionStorage.setItem('payment-successfully', '1');

        // }

        // if (!this.isRealAccountAccess){
        //     localStorage.clear();
        //     sessionStorage.clear()
        //     this.startTimer();
        // }
    }

    startTimer() {
        setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
            } else {
                this._router.navigate(['/pages/signin'])
            }
        }, 1000);
    }

    lanchDashboard(){
        let currentUser = localStorage.getItem('user')
        sessionStorage.setItem('payment-successfully', '1');
        localStorage.removeItem('goto')
        sessionStorage.clear()
        if(currentUser !== null){
            this._spinner.show()
            
            sessionStorage.setItem('auto-login', '1');
            this._userServices.autologin(false)
             

       }else{
           localStorage.clear()
           this._router.navigate(['pages/signin'])
              sessionStorage.removeItem('personal-info')
              sessionStorage.removeItem('business-Info')
              sessionStorage.removeItem('selected-plans')
              sessionStorage.removeItem('selected-hardwares')
              sessionStorage.removeItem('selected-additional-loc-reg')
              sessionStorage.removeItem('grandTotal')
              sessionStorage.removeItem('interval')
              sessionStorage.removeItem('address')
       }
    }
    login() {


       // this._router.navigate(['/pages/signin'])
        let websiteDomain: string = "";
        websiteDomain = window.location.origin + '/'; // this._globals.whiteLabel.domain
        var n = websiteDomain.lastIndexOf('/');
        var result = websiteDomain.substring(n + 1);

        if (result == "") {
            websiteDomain = websiteDomain.substring(0, websiteDomain.length - 1);

        }
        window.location.href = websiteDomain +"/pages/signin"

    }

}
